module.exports = __webpack_public_path__ + "static/img/new1.a0504ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/new1.svg
// module id = BM+i
// module chunks = 0